import { jsx as y, Fragment as $, jsxs as Me } from "react/jsx-runtime";
import { createContext as fe, useState as Ie, useContext as P, useMemo as S, useRef as Ce, useEffect as Le, useId as Ue } from "react";
import n, { z as c } from "zod";
import { JsonLd as w } from "react-schemaorg";
import { useEffectOnce as xe } from "@made-people/react-use-effect-once";
import { isProductMediaImage as ze } from "@made-people/grease-product";
const Fe = n.object({
  "@type": n.literal("BreadcrumbList"),
  itemListElement: n.array(
    n.object({
      "@type": n.literal("ListItem"),
      position: n.number(),
      item: n.object({
        name: n.string(),
        "@id": n.string()
      })
    })
  )
}), Ne = Fe;
function Ee(e) {
  const t = Ne.safeParse(e);
  return t.success, t.success;
}
var k = /* @__PURE__ */ ((e) => (e.FAQPage = "FAQPage", e.Product = "Product", e.ProductList = "ProductList", e.MerchantReturnPolicy = "MerchantReturnPolicy", e.ShippingRateSettings = "ShippingRateSettings", e.WebSite = "WebSite", e))(k || {});
const Ve = {
  structuredDataScripts: {},
  addToScripts: () => {
  },
  removeFromScripts: () => {
  }
}, N = fe(Ve), We = ({
  children: e
}) => {
  const [t, i] = Ie({}), s = (u, o) => {
    u in t && typeof t[u] < "u" && console.info(
      "Structured data script already exists, overwriting it...",
      u
    ), i({ ...t, [u]: o });
  }, a = (u) => {
    if (!(u in t))
      return;
    const { [u]: o, ...r } = t;
    i(r);
  };
  return /* @__PURE__ */ y(
    N.Provider,
    {
      value: {
        structuredDataScripts: t,
        addToScripts: s,
        removeFromScripts: a
      },
      children: e
    }
  );
}, Qe = () => {
  const { structuredDataScripts: e } = P(N);
  return e;
}, $e = () => {
  const { addToScripts: e } = P(N);
  return e;
}, sn = () => {
  const { removeFromScripts: e } = P(N);
  return e;
}, O = fe(void 0), on = (e) => {
  const t = {
    mappers: e.mappers,
    pdpProduct: e.pdpProduct,
    context: e.context,
    offerShippingDetailsSettings: e.offerShippingDetailsSettings,
    merchantReturnPolicySettings: e.merchantReturnPolicySettings,
    breadCrumbs: e.breadCrumbs
  };
  return /* @__PURE__ */ y(O.Provider, { value: t, children: /* @__PURE__ */ y(We, { children: e.children }) });
}, an = () => {
  const e = P(O);
  if (e === void 0)
    throw new Error(
      "useStructuredDataMappers must be used within a StructuredDataProvider"
    );
  return e.mappers;
}, qe = () => {
  const e = P(O);
  if (e === void 0)
    throw new Error(
      "usePdpProduct must be used within a StructuredDataProvider"
    );
  return e.pdpProduct;
}, R = () => {
  const e = P(O);
  if (e === void 0)
    throw new Error(
      "useStructuredDataContext must be used within a StructuredDataProvider"
    );
  return e.context;
}, Be = () => {
  const e = P(O);
  if (e === void 0)
    throw new Error(
      "useShippingDetailsSettings must be used within a StructuredDataProvider"
    );
  return e.offerShippingDetailsSettings;
}, He = () => {
  const e = P(O);
  if (e === void 0)
    throw new Error(
      "useBreadCrumbs must be used within a StructuredDataProvider"
    );
  return e.breadCrumbs;
}, Ge = () => {
  const e = P(O);
  if (e === void 0)
    throw new Error(
      "useMerchantReturnPolicySettings must be used within a StructuredDataProvider"
    );
  return e.merchantReturnPolicySettings;
}, _e = () => {
  const e = He(), { baseUrl: t, siteSlug: i } = R(), s = S(() => {
    if (typeof e > "u" || typeof t > "u" || typeof i > "u")
      return;
    const a = {
      "@type": "BreadcrumbList",
      itemListElement: e.map((u, o) => {
        const r = u.slug === "" ? u.slug : `/${u.slug}`;
        return {
          "@type": "ListItem",
          position: o,
          item: {
            name: u.label,
            "@id": `${t}/${i}${r}`
          }
        };
      })
    };
    if (Ee(a))
      return a;
  }, [e, t]);
  return typeof s > "u" ? null : /* @__PURE__ */ y(
    w,
    {
      item: {
        "@context": "https://schema.org",
        ...s
      }
    }
  );
}, Ke = n.object({
  "@type": n.literal("ImageObject"),
  url: n.string(),
  contentUrl: n.string().optional(),
  caption: n.string().optional(),
  inLanguage: n.string().optional()
}), q = Ke;
function un(e) {
  return q.safeParse(e).success;
}
const Je = n.object({
  "@type": n.literal("Organization"),
  url: n.string(),
  name: n.string(),
  description: n.string().optional(),
  logo: q.optional(),
  sameAs: n.array(n.string()).optional()
}), Xe = Je;
function Ye(e) {
  return Xe.safeParse(e).success;
}
const Ze = (e) => {
  const t = {
    "@type": "Organization",
    url: e.url,
    name: e.name
  };
  if (e.description && (t.description = e.description), e.logoUrl && (t.logo = {
    "@type": "ImageObject",
    url: e.logoUrl,
    contentUrl: e.logoUrl
  }, e.logoCaption && (t.logo.caption = e.logoCaption), e.logoLanguage && (t.logo.inLanguage = e.logoLanguage)), e.sameAs && e.sameAs.length > 0 && (t.sameAs = e.sameAs), !Ye(t)) {
    console.warn(
      "[StructuredDataOrganization]: Could not generate Organization structured data from: ",
      e
    );
    return;
  }
  return t;
}, cn = ({
  config: e
}) => {
  const t = S(() => {
    if (!(typeof e > "u"))
      return Ze(e);
  }, [e]);
  return typeof t > "u" ? null : /* @__PURE__ */ y(
    w,
    {
      item: { "@context": "https://schema.org", ...t }
    }
  );
}, et = n.enum([
  "BackOrder",
  "Discontinued",
  "InStock",
  "InStoreOnly",
  "LimitedAvailability",
  "OnlineOnly",
  "OutOfStock",
  "PreOrder",
  "PreSale",
  "SoldOut"
]), B = et;
function pn(e) {
  const t = B.safeParse(e);
  return t.success, t.success;
}
const tt = n.object({
  "@type": n.literal("MonetaryAmount"),
  value: n.number().optional(),
  minValue: n.number().optional(),
  maxValue: n.number().optional(),
  currency: n.string()
}).refine(
  ({ maxValue: e, minValue: t, value: i }) => typeof e > "u" && typeof t > "u" && typeof i == "number" || typeof e == "number" && typeof t == "number" && typeof i > "u",
  {
    message: "Either both `minValue` and `maxValue` or only `value` have to be defined"
  }
), z = tt;
function de(e) {
  const t = z.safeParse(e);
  return t.success, t.success;
}
const nt = n.object({
  "@type": n.literal("DefinedRegion"),
  addressCountry: n.string().nonempty(),
  addressRegion: n.string().nonempty().optional()
}), H = nt;
function it(e) {
  const t = H.safeParse(e);
  return t.success, t.success;
}
const rt = n.object({
  "@type": n.literal("QuantitativeValue"),
  minValue: n.number(),
  maxValue: n.number(),
  unitCode: n.string()
}).transform((e, t) => {
  switch (e.unitCode) {
    case "min":
    case "minutes": {
      e.unitCode = "min";
      break;
    }
    case "h":
    case "hours": {
      e.unitCode = "h";
      break;
    }
    case "days":
    case "d": {
      e.unitCode = "d";
      break;
    }
    case "wk":
    case "weeks": {
      e.unitCode = "wk";
      break;
    }
    default: {
      t.addIssue({
        fatal: !0,
        path: t.path,
        code: "invalid_enum_value",
        received: e.unitCode,
        options: ["minutes", "hours", "d", "weeks"]
      });
      break;
    }
  }
  return e;
}), F = rt;
function fn(e) {
  const t = F.safeParse(e);
  return t.success, t.success;
}
function ae(e) {
  const t = F.safeParse(e);
  if (t.success)
    return t.data;
}
const st = n.enum([
  "Monday",
  "https://schema.org/Monday",
  "Tuesday",
  "https://schema.org/Tuesday",
  "Wednesday",
  "https://schema.org/Wednesday",
  "Thursday",
  "https://schema.org/Thursday",
  "Friday",
  "https://schema.org/Friday",
  "Saturday",
  "https://schema.org/Saturday",
  "Sunday",
  "https://schema.org/Sunday"
]), le = st;
function dn(e) {
  const t = le.safeParse(e);
  return t.success, t.success;
}
const ot = n.object({
  "@type": n.literal("ShippingDeliveryTime"),
  cutoffTime: n.string().nonempty().optional(),
  handlingTime: F.optional(),
  transitTime: F.optional(),
  businessDays: n.object({
    "@type": n.literal("OpeningHoursSpecification"),
    dayOfWeek: le.array()
  })
}), ge = ot;
function at(e) {
  const t = ge.safeParse(e);
  return t.success, t.success;
}
const ut = n.object({
  "@type": n.literal("OfferShippingDetails"),
  shippingSettingsLink: n.string(),
  deliveryTime: ge.optional(),
  shippingRate: z,
  shippingDestination: H
}), me = ut;
function ct(e) {
  const t = me.safeParse(e);
  return t.success, t.success;
}
const pt = n.object({
  "@type": n.literal("Offer"),
  price: n.number(),
  name: n.string().optional(),
  priceCurrency: n.string(),
  availability: B,
  shippingDetails: me.optional()
}), G = pt;
function ln(e) {
  const t = G.safeParse(e);
  return t.success, t.success;
}
const ft = n.object({
  "@type": n.literal("SizeSpecification"),
  name: n.string().nonempty(),
  sizeSystem: n.string().nonempty().optional(),
  sizeGroup: n.string().nonempty().optional()
}), dt = n.object({
  "@type": n.literal("ProductModel"),
  sku: n.string().nonempty(),
  name: n.string().nonempty(),
  mpn: n.string().nonempty().optional(),
  gtin13: n.string().nonempty().optional(),
  size: n.union([n.string().nonempty(), ft]).optional(),
  image: n.string().array().nonempty().optional(),
  color: n.string().nonempty().optional(),
  offers: G,
  url: n.string()
}).refine(
  (e) => !(typeof e.size > "u" && typeof e.color > "u"),
  {
    message: "Both `size` and `color` cannot be undefined simultaneously on a product model"
  }
), _ = dt;
function gn(e) {
  return _.safeParse(e).success;
}
function lt(e) {
  if (typeof e > "u")
    return;
  const t = _.safeParse(e);
  if (t.success)
    return t.data;
}
const gt = n.object({
  "@type": n.literal("AggregateOffer"),
  lowPrice: n.number(),
  highPrice: n.number(),
  name: n.string().optional(),
  priceCurrency: n.string(),
  availability: B
}), ye = gt;
function mn(e) {
  const t = ye.safeParse(e);
  return t.success, t.success;
}
const mt = n.object({
  "@type": n.literal("AggregateRating"),
  ratingValue: n.union([n.number(), n.string()]),
  bestRating: n.union([n.number(), n.string()]).optional(),
  worstRating: n.union([n.number(), n.string()]).optional(),
  ratingCount: n.number().int().positive().optional(),
  reviewCount: n.number().int().positive().optional()
}), K = mt;
function yn(e) {
  return K.safeParse(e).success;
}
function hn(e) {
  const t = K.safeParse(e);
  if (t.success)
    return t.data;
}
const yt = n.object({
  "@type": n.literal("Rating"),
  ratingValue: n.union([n.number(), n.string()]),
  bestRating: n.union([n.number(), n.string()]).optional(),
  worstRating: n.union([n.number(), n.string()]).optional(),
  author: n.union([
    n.object({
      "@type": n.literal("Person"),
      name: n.string()
    }),
    n.object({
      "@type": n.literal("Organization"),
      name: n.string()
    })
  ]).optional()
}), J = yt;
function Sn(e) {
  return J.safeParse(e).success;
}
function bn(e) {
  const t = J.safeParse(e);
  if (t.success)
    return t.data;
}
const ht = n.object({
  "@type": n.literal("Review"),
  reviewBody: n.string().optional(),
  reviewRating: J.optional(),
  author: n.union([
    n.object({
      "@type": n.literal("Person"),
      name: n.string()
    }),
    n.object({
      "@type": n.literal("Organization"),
      name: n.string()
    })
  ]).optional(),
  datePublished: n.string().optional(),
  name: n.string().optional(),
  description: n.string().optional(),
  reviewAspect: n.string().optional(),
  positiveNotes: n.string().optional(),
  negativeNotes: n.string().optional()
}), X = ht;
function vn(e) {
  return X.safeParse(e).success;
}
function Pn(e) {
  const t = X.safeParse(e);
  if (t.success)
    return t.data;
}
const St = n.object({
  "@type": n.literal("MerchantReturnPolicy"),
  applicableCountry: n.string().optional(),
  returnPolicyCategory: n.enum([
    "MerchantReturnFiniteReturnWindow",
    "MerchantReturnNotPermitted",
    "MerchantReturnUnlimitedWindow",
    "MerchantReturnUnspecified"
  ]).optional(),
  merchantReturnDays: n.number().min(0).optional(),
  returnMethod: n.enum(["ReturnAtKiosk", "ReturnByMail", "ReturnInStore"]).optional(),
  returnFees: n.enum([
    "FreeReturn",
    "ReturnFeesCustomerResponsibility",
    "ReturnShippingFees"
  ]).optional(),
  inStoreReturnsOffered: n.boolean().optional()
}), he = St;
function Rn(e) {
  const t = he.safeParse(e);
  return t.success, t.success;
}
const bt = n.object({
  "@type": n.literal("Brand"),
  name: n.string().nonempty()
}), vt = bt, Pt = n.object({
  "@type": n.literal("Country"),
  name: n.string().nonempty()
}), Rt = Pt, wt = n.object({
  "@type": n.literal("Product"),
  sku: n.string().nonempty(),
  name: n.string().nonempty(),
  description: n.string().nonempty().optional(),
  image: n.string().array().nonempty().optional(),
  brand: vt.optional(),
  countryOfOrigin: Rt.optional(),
  gtin13: n.string().nonempty().optional(),
  offers: G.or(ye),
  model: n.array(_).nonempty().optional(),
  url: n.string(),
  aggregateRating: K.optional(),
  review: n.array(X).optional(),
  hasMerchantReturnPolicy: he.optional()
}).refine(
  (e) => {
    var t;
    return !(typeof e.model < "u" && ((t = e.offers) == null ? void 0 : t["@type"]) === "Offer");
  },
  {
    message: "If `model` is defined, `offers` need to be of type 'AggregateOffer'"
  }
).refine(
  (e) => {
    var t;
    return !(typeof e.model > "u" && ((t = e.offers) == null ? void 0 : t["@type"]) === "AggregateOffer");
  },
  {
    message: "If `model` is undefined, `offers` need to be of type 'Offer'"
  }
).refine(
  (e) => !(typeof e.model > "u" && typeof e.offers > "u"),
  { message: "Both `model` and `offers` cannot be undefined simultaneously" }
), Y = wt;
function Ot(e) {
  return Y.safeParse(e).success;
}
function Tt(e) {
  const t = Y.safeParse(e);
  if (t.success)
    return t.data;
}
const Dt = n.object({
  "@type": n.literal("ItemList"),
  itemListElement: n.array(
    n.object({
      "@type": n.literal("ListItem"),
      position: n.number(),
      item: Y
    })
  )
}), Se = Dt;
function kt(e) {
  return Se.safeParse(e).success;
}
function wn(e) {
  const t = Se.safeParse(e);
  if (t.success)
    return t.data;
}
const be = c.object({
  applicableCountry: c.string().optional(),
  returnPolicyCategory: c.enum([
    "MerchantReturnFiniteReturnWindow",
    "MerchantReturnNotPermitted",
    "MerchantReturnUnlimitedWindow",
    "MerchantReturnUnspecified"
  ]).optional(),
  merchantReturnDays: c.number().min(0).optional(),
  returnMethod: c.enum(["ReturnAtKiosk", "ReturnByMail", "ReturnInStore"]).optional(),
  returnFees: c.enum([
    "FreeReturn",
    "ReturnFeesCustomerResponsibility",
    "ReturnShippingFees"
  ]).optional(),
  inStoreReturnsOffered: c.boolean().optional()
});
function On(e) {
  return be.safeParse(e).success;
}
const ve = be.array().nonempty();
function jt(e) {
  return ve.safeParse(e).success;
}
function Tn(e, t) {
  const i = ve.safeParse(e);
  if (!i.success) {
    t == null || t(i.error);
    return;
  }
  return i.data;
}
const At = (e) => {
  const { country: t, baseUrl: i } = R();
  return S(() => {
    var a, u, o, r, p, d;
    return jt(e) ? {
      "@type": "MerchantReturnPolicy",
      applicableCountry: ((a = e == null ? void 0 : e[0]) == null ? void 0 : a.applicableCountry) || t,
      returnPolicyCategory: (u = e == null ? void 0 : e[0]) == null ? void 0 : u.returnPolicyCategory,
      merchantReturnDays: (o = e == null ? void 0 : e[0]) == null ? void 0 : o.merchantReturnDays,
      returnMethod: (r = e == null ? void 0 : e[0]) == null ? void 0 : r.returnMethod,
      returnFees: (p = e == null ? void 0 : e[0]) == null ? void 0 : p.returnFees,
      inStoreReturnsOffered: (d = e == null ? void 0 : e[0]) == null ? void 0 : d.inStoreReturnsOffered
    } : void 0;
  }, [e, t, i]);
}, ue = c.object({
  unit: c.enum(["days", "hours", "minutes", "seconds"]),
  endTime: c.number(),
  startTime: c.number(),
  isEnabled: c.boolean()
}), Pe = c.object({
  cutoffTime: c.string().optional(),
  handlingTime: ue,
  transitTime: ue
});
function Dn(e) {
  const t = Pe.safeParse(e);
  return t.success || console.warn(
    "Failed to parse type shippingDeliveryTimeSettingSchema: ",
    t.error
  ), t.success;
}
const Re = c.object({
  countries: c.string().array().nonempty(),
  deliveryTime: Pe.array().min(1).max(1).optional(),
  region: c.string().optional(),
  shippingRateMin: c.string(),
  shippingRateMax: c.string(),
  freeShippingThreshold: c.string().optional(),
  shippingSettingsLink: c.object({
    href: c.string()
  }).optional()
});
function kn(e) {
  return Re.safeParse(e).success;
}
const we = Re.array().nonempty();
function j(e) {
  return we.safeParse(e).success;
}
function jn(e, t) {
  const i = we.safeParse(e);
  if (!i.success) {
    t == null || t(i.error);
    return;
  }
  return i.data;
}
const Mt = (e) => {
  const { country: t, currencyCode: i } = R();
  return S(() => {
    if (!j(e))
      return;
    const s = /* @__PURE__ */ new Map();
    for (const a of e) {
      if (!a.countries.includes(t))
        continue;
      const u = a.countries.join("");
      if (s.has(u)) {
        console.warn(`Duplicate key ${u} in StructuredDataShippingRate`);
        continue;
      }
      let o = parseInt(
        a.shippingRateMin
      );
      isNaN(o) && (o = void 0);
      let r = parseInt(
        a.shippingRateMax
      );
      isNaN(r) && (r = void 0);
      let p;
      typeof o == "number" && typeof r == "number" && (p = {
        "@type": "MonetaryAmount",
        minValue: o,
        maxValue: r,
        currency: i
      }), de(p) && s.set(u, p);
    }
    if (s.size !== 0)
      return s;
  }, [e, t, i]);
}, It = (e) => {
  const { country: t } = R();
  return S(() => {
    if (!j(e))
      return;
    const i = /* @__PURE__ */ new Map();
    for (const s of e) {
      if (!s.countries.includes(t))
        continue;
      const a = s.countries.join("");
      if (i.has(a)) {
        console.warn(`Duplicate key ${a} in StructuredDataShippingRate`);
        continue;
      }
      const u = {
        "@type": "DefinedRegion",
        addressCountry: t
      };
      typeof s.region == "string" && s.region.length > 0 && (u.addressRegion = s.region), it(u) && i.set(a, u);
    }
    if (i.size !== 0)
      return i;
  }, [e, t]);
}, Ct = (e) => {
  const { country: t } = R();
  return S(() => {
    var s;
    if (!j(e))
      return;
    const i = /* @__PURE__ */ new Map();
    for (const a of e) {
      if (!a.countries.includes(t))
        continue;
      const u = a.countries.join("");
      if (i.has(u)) {
        console.warn(`Duplicate key ${u} in StructuredDataShippingRate`);
        continue;
      }
      if (typeof a > "u" || !Array.isArray(a.deliveryTime) || typeof a.deliveryTime[0] > "u")
        continue;
      const [o] = a.deliveryTime, r = {
        "@type": "ShippingDeliveryTime",
        businessDays: {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: [
            "https://schema.org/Monday",
            "https://schema.org/Tuesday",
            "https://schema.org/Wednesday",
            "https://schema.org/Thursday",
            "https://schema.org/Friday"
          ]
        }
      };
      if (o.handlingTime.isEnabled === !0 && (r.handlingTime = {
        "@type": "QuantitativeValue",
        minValue: o.handlingTime.startTime,
        maxValue: o.handlingTime.endTime,
        unitCode: o.handlingTime.unit
      }, r.handlingTime = ae(r.handlingTime)), o.transitTime.isEnabled === !0 && (r.transitTime = {
        "@type": "QuantitativeValue",
        minValue: o.transitTime.startTime,
        maxValue: o.transitTime.endTime,
        unitCode: o.transitTime.unit
      }, r.transitTime = ae(r.transitTime)), typeof o.cutoffTime == "string" && /(([0-1][0-9])|(2[0-3])):[0-5][0-9]/.test(o.cutoffTime)) {
        const [p, d] = o.cutoffTime.split(
          ":"
        );
        let m = parseInt(p);
        (isNaN(m) || m > 23 || m < 0) && (m = void 0);
        let l = parseInt(d);
        if ((isNaN(l) || l > 59 || l < 0) && (l = void 0), typeof m < "u") {
          const g = /* @__PURE__ */ new Date();
          g.setUTCHours(m, l ?? 0, 0, 0), r.cutoffTime = (s = g.toJSON().split("T")) == null ? void 0 : s[1];
        }
      }
      Object.values(r ?? {}).filter((p) => typeof p < "u").length < 1 || at(r) && i.set(u, r);
    }
    if (i.size !== 0)
      return i;
  }, [e, t]);
}, Z = (e) => {
  const t = Mt(
    e
  ), i = It(
    e
  ), s = Ct(
    e
  ), { country: a, baseUrl: u } = R();
  return S(() => {
    if (!j(e) || typeof i > "u" || typeof t > "u" || typeof s > "u")
      return;
    const o = /* @__PURE__ */ new Map();
    for (const r of e) {
      if (!r.countries.includes(a))
        continue;
      const p = r.countries.join("");
      if (o.has(p)) {
        console.warn(`Duplicate key ${p} in OfferShippingDetails`);
        continue;
      }
      const d = t.get(p), m = i.get(p), l = s.get(p);
      if (typeof d > "u" || typeof m > "u" || typeof l > "u")
        return;
      const g = r == null ? void 0 : r.shippingSettingsLink, b = {
        "@type": "OfferShippingDetails",
        shippingDestination: m,
        deliveryTime: l,
        // @ts-expect-error - setting shippingRate to undefined is intentional
        shippingRate: void 0
      };
      g && (b.shippingSettingsLink = `${u}${g.href}`), de(d) && (b.shippingRate = d), ct(b) && o.set(p, b);
    }
    if (o.size !== 0)
      return o;
  }, [
    e,
    t,
    i,
    s,
    a,
    u
  ]);
};
function ce(e) {
  if (typeof e != "string")
    return !1;
  try {
    new URL(e);
  } catch {
    return !1;
  }
  return !0;
}
function pe(e, t, i, s, a = !0, u, o) {
  var ne, ie, re, I, se;
  const r = {
    "@type": "Product",
    name: e.name
  }, p = e.sku, d = e.name, m = e.description, l = e.countryOfOrigin, g = e.priceAsNumber, b = e.brandName, A = (ne = e.imageUrls) == null ? void 0 : ne.filter((f) => ce(f)), E = e.urlSlug;
  if (typeof p > "u") {
    console.warn(
      `[useStructuredDataProduct]: Invalid sku for product, got ${p}. Product object: `,
      e
    );
    return;
  }
  let T = 1 / 0, M = 0;
  for (let f = 0; f < e.variants.length; ++f) {
    const h = e.variants[f];
    if (typeof h > "u")
      continue;
    const v = {
      "@type": "ProductModel"
    }, C = h.sku, L = h.size, W = h.ean, U = h.priceAsNumber ?? g;
    let x = (ie = h.imageUrls) == null ? void 0 : ie.filter((Ae) => ce(Ae));
    if (typeof x > "u" && (x = A), typeof C == "string" && C.length > 0)
      v.sku = C;
    else {
      console.warn(
        `[useStructuredDataProduct]: Invalid sku for variant, got ${C}. Variant object: `,
        h
      );
      continue;
    }
    typeof d == "string" && d.length > 0 && (v.name = d), typeof L == "string" && L.length > 0 && (typeof h.sizeSystem == "string" && h.sizeSystem.length > 0 ? v.size = {
      "@type": "SizeSpecification",
      name: L,
      sizeSystem: h.sizeSystem
    } : v.size = L), typeof W == "string" && W.length > 0 && (v.gtin13 = W), c.string().nonempty().array().nonempty().safeParse(x).success && (v.image = x), typeof t == "string" && t.length > 0 && typeof U == "number" && typeof h.quantity == "number" && (v.offers = {
      "@type": "Offer",
      price: U,
      priceCurrency: t,
      availability: h.quantity > 0 ? "InStock" : "OutOfStock",
      ...o && { shippingDetails: o }
    }, T = Math.min(T, U), M = Math.max(T, U));
    const Q = h.urlSlug ?? e.urlSlug;
    typeof i == "string" && i.length > 0 && typeof Q == "string" && Q.length > 0 && (v.url = `${i}/${s}/${Q}`);
    const oe = lt(v);
    typeof oe > "u" || (r.model = [
      oe,
      ...r.model ?? []
    ]);
  }
  if (typeof b == "string" && b.length > 0 && (r.brand = {
    "@type": "Brand",
    name: b
  }), e.variants.length === 1) {
    const f = (re = e.variants[0]) == null ? void 0 : re.ean;
    typeof f == "string" && f.length > 0 && (r.gtin13 = f);
  }
  typeof p == "string" && p.length > 0 && (r.sku = p), typeof d == "string" && d.length > 0 && (r.name = d), typeof m == "string" && m.length > 0 && (r.description = m), typeof t == "string" && t.length > 0 && typeof r.model < "u" && (typeof g == "number" || typeof T == "number" && typeof M == "number") ? r.offers = {
    "@type": "AggregateOffer",
    lowPrice: typeof T == "number" ? T : g,
    highPrice: typeof M == "number" ? M : g,
    priceCurrency: t,
    availability: r.model.some(
      (f) => f.offers.availability === "InStock"
    ) ? "InStock" : "OutOfStock"
  } : typeof r.model > "u" && typeof t == "string" && t.length > 0 && typeof g == "number" && (r.offers = {
    "@type": "Offer",
    price: g,
    priceCurrency: t,
    availability: (se = (I = e.variants) == null ? void 0 : I.some) != null && se.call(
      I,
      (f) => typeof (f == null ? void 0 : f.quantity) == "number" && (f == null ? void 0 : f.quantity) > 0
    ) ? "InStock" : "OutOfStock",
    ...o && { shippingDetails: o }
  }), typeof i == "string" && i.length > 0 && typeof E == "string" && E.length > 0 && (r.url = `${i}/${s}/${E}`), typeof A < "u" && c.string().array().nonempty().safeParse(A).success && (r.image = A), typeof l == "string" && l.length > 0 && (r.countryOfOrigin = {
    "@type": "Country",
    name: l
  });
  const D = a ? e.aggregateRating : void 0, V = a ? e.reviews : void 0;
  return D && (r.aggregateRating = {
    "@type": "AggregateRating",
    ratingValue: D.ratingValue,
    bestRating: D.bestRating,
    worstRating: D.worstRating,
    reviewCount: D.reviewCount,
    ratingCount: D.ratingCount
  }), V && V.length > 0 && (r.review = V.map((f) => ({
    "@type": "Review",
    reviewBody: f.reviewBody,
    reviewRating: f.reviewRating ? {
      "@type": "Rating",
      ratingValue: f.reviewRating.ratingValue,
      bestRating: f.reviewRating.bestRating,
      worstRating: f.reviewRating.worstRating
    } : void 0,
    author: f.author ? {
      "@type": f.author.type,
      name: f.author.name
    } : void 0,
    datePublished: f.datePublished,
    name: f.name,
    description: f.description,
    reviewAspect: f.reviewAspect,
    positiveNotes: f.positiveNotes,
    negativeNotes: f.negativeNotes
  }))), u && (r.hasMerchantReturnPolicy = u), Tt(r);
}
function Oe(e) {
  const { currencyCode: t, baseUrl: i, siteSlug: s, country: a } = R(), u = Ge(), o = Be(), r = At(
    u
  ), p = Z(
    o
  ), d = a, m = p == null ? void 0 : p.get(d);
  return S(() => {
    if (!(typeof e > "u" || typeof t > "u" || typeof i > "u" || typeof s > "u"))
      if (Array.isArray(e)) {
        if (e.length === 0)
          return;
        const l = {
          "@type": "ItemList",
          itemListElement: []
        };
        for (let g = 0; g < e.length; ++g) {
          const b = e[g];
          typeof b > "u" || l.itemListElement.push({
            "@type": "ListItem",
            position: g + 1,
            item: pe(
              b,
              t,
              i,
              s,
              !1,
              // Don't include reviews for product lists
              r,
              m
            )
          });
        }
        return kt(l) ? l : void 0;
      } else
        return pe(
          e,
          t,
          i,
          s,
          !0,
          // Include reviews for single product (PDP)
          r,
          m
        );
  }, [
    e,
    t,
    i,
    s,
    r,
    m
  ]);
}
const Lt = ({
  unformattedProducts: e
}) => {
  const t = Oe(e), i = Ce(0);
  return Le(() => {
    i.current += 1;
  }, [t]), typeof t > "u" ? null : /* @__PURE__ */ y(
    w,
    {
      item: {
        "@context": "https://schema.org",
        ...t
      }
    },
    i.current
  );
}, Ut = ({ settings: e }) => {
  const t = Z(e);
  return /* @__PURE__ */ y($, { children: [...(t == null ? void 0 : t.entries()) ?? []].map(
    ([i, s]) => /* @__PURE__ */ y(
      w,
      {
        item: {
          "@context": "https://schema.org",
          ...s
        }
      },
      i
    )
  ) });
}, xt = n.object({
  "@type": n.literal("ShippingRateSettings"),
  shippingRate: z,
  freeShippingThreshold: z,
  shippingDestination: H
}), Te = xt;
function zt(e) {
  const t = Te.safeParse(e);
  return t.success, t.success;
}
function An(e) {
  const t = Te.safeParse(e);
  if (t.success)
    return t.data;
}
const Ft = ({ settings: e }) => {
  const { country: t, currencyCode: i, currentPath: s } = R(), a = Z(e), u = S(() => {
    var r;
    if (!j(e) || typeof a > "u")
      return;
    const o = /* @__PURE__ */ new Map();
    for (const p of e) {
      if (!p.countries.includes(t))
        continue;
      const d = p.countries.join(""), m = a.get(d);
      if (typeof m > "u" || ((r = p.shippingSettingsLink) == null ? void 0 : r.href) !== s)
        continue;
      const l = {
        ...m,
        "@type": "ShippingRateSettings"
      };
      if (delete l.deliveryTime, delete l.shippingSettingsLink, typeof p.freeShippingThreshold == "string") {
        let g = parseFloat(
          p.freeShippingThreshold
        );
        isNaN(g) && (g = void 0), typeof g < "u" && (l.freeShippingThreshold = {
          "@type": "MonetaryAmount",
          value: g,
          currency: i
        });
      }
      if (o.has(d)) {
        console.warn(`Duplicate key ${d} in ShippingRateSettings`);
        continue;
      }
      zt(l) && o.set(d, l);
    }
    if (o.size !== 0)
      return o;
  }, [a, e]);
  return /* @__PURE__ */ y($, { children: [...(u == null ? void 0 : u.entries()) ?? []].map(
    ([o, r]) => /* @__PURE__ */ y(
      w,
      {
        item: {
          "@context": "https://schema.org",
          ...r
        }
      },
      o
    )
  ) });
}, Nt = n.object({
  "@type": n.literal("SearchAction"),
  target: n.object({
    "@type": n.literal("EntryPoint"),
    urlTemplate: n.string()
  }),
  "query-input": n.string()
}), De = Nt;
function Mn(e) {
  return De.safeParse(e).success;
}
const Et = n.object({
  "@type": n.literal("WebSite"),
  "@context": n.literal("https://schema.org/"),
  url: n.string(),
  name: n.string(),
  description: n.string().optional(),
  inLanguage: n.string().optional(),
  keywords: n.string().optional(),
  potentialAction: De.optional(),
  logo: q.optional(),
  sameAs: n.array(n.string()).optional()
}), Vt = Et;
function Wt(e) {
  return Vt.safeParse(e).success;
}
const ee = (e, t) => {
  const i = $e(), s = Ue();
  xe(
    () => {
      if (typeof e > "u")
        return;
      const a = `schema-org-script-${e.name ?? e["@type"] ?? t}-${s}`, u = /* @__PURE__ */ y(
        w,
        {
          item: {
            "@context": "https://schema.org",
            ...e
          }
        },
        a
      );
      i(t, u);
    },
    {
      ifDefined: [e]
    }
  );
}, ke = (e) => {
  const t = {
    "@type": "WebSite",
    "@context": "https://schema.org/",
    url: e.url,
    name: e.name
  };
  if (e.description && (t.description = e.description), e.inLanguage && (t.inLanguage = e.inLanguage), e.keywords && (t.keywords = e.keywords), e.searchActionUrlTemplate && (t.potentialAction = {
    "@type": "SearchAction",
    target: {
      "@type": "EntryPoint",
      urlTemplate: e.searchActionUrlTemplate
    },
    "query-input": "required name=search_term_string"
  }), e.logoUrl && (t.logo = {
    "@type": "ImageObject",
    url: e.logoUrl,
    contentUrl: e.logoUrl
  }, e.logoCaption && (t.logo.caption = e.logoCaption), e.logoLanguage && (t.logo.inLanguage = e.logoLanguage)), e.sameAs && e.sameAs.length > 0 && (t.sameAs = e.sameAs), !Wt(t)) {
    console.warn(
      "[useInjectWebSite]: Could not generate WebSite structured data from: ",
      e,
      " generated: ",
      t,
      ", which is not valid SchemaOrg format"
    );
    return;
  }
  return t;
}, In = (e) => {
  const t = S(() => {
    if (!(typeof e > "u"))
      return ke(e);
  }, [e]);
  ee(t, k.WebSite);
}, Cn = ({
  config: e
}) => {
  const t = S(() => {
    if (!(typeof e > "u"))
      return ke(e);
  }, [e]);
  return typeof t > "u" ? null : /* @__PURE__ */ y(
    w,
    {
      item: { ...t, "@context": "https://schema.org" }
    }
  );
}, Ln = ({
  offerShippingDetailsSettings: e
}) => {
  const t = qe(), i = Qe();
  return /* @__PURE__ */ Me($, { children: [
    Object.entries(i).filter(([s]) => !(typeof t < "u" && s === k.ProductList)).map(([, s]) => s),
    /* @__PURE__ */ y(_e, {}),
    /* @__PURE__ */ y(Ut, { settings: e }),
    /* @__PURE__ */ y(
      Ft,
      {
        settings: e
      }
    ),
    /* @__PURE__ */ y(Lt, { unformattedProducts: t })
  ] });
}, Qt = n.object({
  "@type": n.literal("FAQPage"),
  mainEntity: n.array(
    n.object({
      "@type": n.literal("Question"),
      name: n.string(),
      acceptedAnswer: n.object({
        "@type": n.literal("Answer"),
        text: n.string()
      })
    })
  ).nonempty()
}), $t = Qt;
function qt(e) {
  const t = $t.safeParse(e);
  return t.success, t.success;
}
const Bt = (e) => {
  if (e.length === 0)
    return;
  const t = {
    "@type": "FAQPage"
  };
  let i = [];
  for (const { q: s, a } of e) {
    if (typeof s != "string" || typeof a != "string") {
      console.warn("[useInjectFAQPage]: Wrong input, got", { q: s, a });
      continue;
    }
    i = [
      ...i,
      {
        "@type": "Question",
        name: s,
        acceptedAnswer: {
          "@type": "Answer",
          text: a
        }
      }
    ];
  }
  if (t.mainEntity = i, !qt(t)) {
    console.warn(
      "[useInjectFAQPage]: Could not generate FAQ Page structured data from: ",
      e,
      " generated: ",
      t,
      ", which is not valid SchemaOrg format"
    );
    return;
  }
  return t;
}, Un = (e) => {
  const t = S(() => {
    if (!(typeof e > "u"))
      return Bt(e);
  }, [e]);
  ee(t, k.FAQPage);
}, xn = (e) => {
  const t = Oe(e);
  ee(
    t,
    Ot(t) ? k.Product : k.ProductList
  );
}, Ht = n.object({
  a: n.string(),
  q: n.string()
}), je = n.object({
  qa: n.array(Ht)
});
function zn(e) {
  return je.safeParse(e).success;
}
function Fn(e) {
  const t = je.safeParse(e);
  if (t.success)
    return t.data;
}
const Nn = n.object({
  name: n.string(),
  description: n.string().optional(),
  keywords: n.string().optional(),
  logoUrl: n.string(),
  logoCaption: n.string().optional(),
  sameAs: n.string().optional()
}), Gt = c.object({
  sku: c.string(),
  name: c.string(),
  uri: c.string(),
  excerpt: c.string().optional(),
  brandName: c.string().nullish(),
  countryOrigin: c.string().optional().nullable(),
  price: c.object({
    priceAsNumber: c.number()
  }),
  mediaUrls: c.array(c.string()),
  frontendItems: c.array(
    c.object({
      sku: c.string(),
      name: c.string(),
      ean: c.string().optional(),
      quantity: c.number().optional()
    })
  )
});
function _t(e) {
  const t = Gt.safeParse(e);
  return t.success || console.warn(
    "Type validation of StructuredDataFormattableCentraProduct failed: ",
    t.error
  ), t.success;
}
function En(e) {
  if (!(typeof e > "u") && _t(e))
    return {
      sku: e.sku,
      name: e.name,
      description: e.excerpt,
      brandName: e.brandName ?? void 0,
      priceAsNumber: e.price.priceAsNumber,
      imageUrls: e.mediaUrls,
      countryOfOrigin: e.countryOrigin,
      urlSlug: e.uri,
      variants: e.frontendItems.map((t) => ({
        sku: t.sku,
        size: t.name,
        ean: t.ean,
        imageUrls: e.mediaUrls,
        quantity: t.quantity
      }))
    };
}
function Vn(e) {
  switch (e.dataModel) {
    case "simple":
      return Kt(e);
    case "with_variants":
      return Jt(e);
    case "bundle":
      return Xt(e);
    default:
      throw new Error("Unsupported product type" + e.dataModel);
  }
}
function Kt(e) {
  const t = te(e);
  return {
    sku: e.sku,
    name: e.base.content.name,
    description: e.base.content.description,
    brandName: e.base.content.brand,
    priceAsNumber: e.priceInfo.price.number,
    imageUrls: t,
    urlSlug: e.base.slug,
    variants: [
      {
        sku: e.sku,
        size: "One size",
        ean: e.ean,
        imageUrls: t,
        quantity: e.inventory.quantity
      }
    ]
  };
}
function Jt(e) {
  var i;
  const t = te(e);
  return {
    sku: e.base.productId,
    name: e.base.content.name,
    description: e.base.content.description,
    brandName: e.base.content.brand,
    priceAsNumber: (i = e.variants[0]) == null ? void 0 : i.priceInfo.price.number,
    imageUrls: t,
    urlSlug: e.base.slug,
    variants: e.variants.map((s) => ({
      sku: s.sku,
      size: s.label,
      ean: s.ean,
      imageUrls: t,
      quantity: s.inventory.quantity
    }))
  };
}
function Xt(e) {
  const t = te(e);
  return {
    sku: e.bundlePurchaseInfo.sku,
    name: e.base.content.name,
    description: e.base.content.description,
    brandName: e.base.content.brand,
    priceAsNumber: e.bundlePurchaseInfo.priceInfo.price.number,
    imageUrls: t,
    urlSlug: e.base.slug,
    variants: [
      {
        sku: e.bundlePurchaseInfo.sku,
        size: "Bundle",
        imageUrls: t,
        quantity: e.bundlePurchaseInfo.inventory.quantity
      }
    ]
  };
}
function te(e) {
  return e.base.content.media.filter(ze).map((t) => t.src);
}
export {
  We as GearsStructuredDataContextProvider,
  Ln as GearsStructuredDataHeadTag,
  _e as StructuredDataBreadcrumbs,
  cn as StructuredDataOrganization,
  Lt as StructuredDataProducts,
  on as StructuredDataProvider,
  k as StructuredDataScriptName,
  Ut as StructuredDataShippingDetails,
  Ft as StructuredDataShippingRateSettings,
  Cn as StructuredDataWebSite,
  ye as aggregateOfferSchema,
  K as aggregateRatingSchema,
  vt as brandSchema,
  Ne as breadcrumbListSchema,
  Rt as countrySchema,
  le as dayOfWeekSchema,
  En as defaultMapCentraProductToStructuredDataProduct,
  H as definedRegionSchema,
  $t as faqPageSchema,
  Ze as generateOrganization,
  ke as generateWebSite,
  Vn as greaseProductToUnformattedStructuredDataProduct,
  q as imageObjectSchema,
  mn as isAggregateOffer,
  yn as isAggregateRating,
  Ee as isBreadcrumbList,
  dn as isDayOfWeek,
  it as isDefinedRegion,
  qt as isFAQPage,
  un as isImageObject,
  pn as isItemAvailability,
  Rn as isMerchantReturnPolicy,
  jt as isMerchantReturnPolicySettings,
  On as isMerchantReturnPolicySettingsEntry,
  de as isMonetaryAmount,
  ln as isOffer,
  ct as isOfferShippingDetails,
  j as isOfferShippingDetailsSettings,
  kn as isOfferShippingDetailsSettingsEntry,
  Ye as isOrganization,
  Ot as isProduct,
  kt as isProductList,
  gn as isProductModel,
  fn as isQuantitativeValue,
  Sn as isRating,
  vn as isReview,
  Mn as isSearchAction,
  at as isShippingDeliveryTime,
  Dn as isShippingDeliveryTimeSetting,
  zt as isShippingRateSettings,
  zn as isStoryblokFAQPage,
  Wt as isWebSite,
  B as itemAvailabilitySchema,
  he as merchantReturnPolicySchema,
  be as merchantReturnPolicySettingsEntrySchema,
  ve as merchantReturnPolicySettingsSchema,
  z as monetaryAmountSchema,
  G as offerSchema,
  me as offerShippingDetailsSchema,
  Re as offerShippingDetailsSettingsEntrySchema,
  we as offerShippingDetailsSettingsSchema,
  Xe as organizationSchema,
  Se as productListSchema,
  _ as productModelSchema,
  Y as productSchema,
  F as quantitativeValueSchema,
  J as ratingSchema,
  X as reviewSchema,
  De as searchActionSchema,
  ge as shippingDeliveryTimeSchema,
  Pe as shippingDeliveryTimeSettingSchema,
  Te as shippingRateSettingsSchema,
  ue as storyblokTimeRangeFieldTypeSchema,
  O as structuredDataContext,
  hn as toAggregateRatingOrUndefined,
  Tn as toMerchantReturnPolicySettingsOrUndefined,
  jn as toOfferShippingDetailsSettingsOrUndefined,
  wn as toProductListOrUndefined,
  lt as toProductModelOrUndefined,
  Tt as toProductOrUndefined,
  ae as toQuantitativeValueOrUndefined,
  bn as toRatingOrUndefined,
  Pn as toReviewOrUndefined,
  An as toShippingRateSettingsOrUndefined,
  Fn as toStoryblokFAQPageOrUndefined,
  $e as useAddGearsStructuredDataHeadTagScript,
  He as useBreadCrumbs,
  Qe as useGearsStructuredDataHeadTagScripts,
  Un as useInjectFAQPage,
  xn as useInjectStructuredDataProducts,
  In as useInjectWebSite,
  Ge as useMerchantReturnPolicySettings,
  qe as usePdpProduct,
  sn as useRemoveGearsStructuredDataHeadTagScript,
  Be as useShippingDetailsSettings,
  R as useStructuredDataContext,
  ee as useStructuredDataInjector,
  an as useStructuredDataMappers,
  At as useStructuredDataMerchantReturnPolicy,
  Z as useStructuredDataOfferShippingDetails,
  Oe as useStructuredDataProduct,
  Ct as useStructuredDataShippingDeliveryTime,
  It as useStructuredDataShippingDestination,
  Mt as useStructuredDataShippingRate,
  Vt as webSiteSchema,
  Nn as webSiteSettingsSchema
};
